import { colors } from '@mui/material';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0,

  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },

  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center',
    fontSize:9
  },
  columnContent1: {
    width: '6%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};
const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const DoctorWiseOpdProceduresReportPdf = ({ data }) => {
  console.log(data);
  const user = JSON.parse(localStorage.getItem('user'));

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Doctor Wise Opd And Procedures Report ">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text style={{ ...styles.columnHeader, width: '10%' }} content="Sr No" />
              <Text style={{...styles.columnHeader,width:"10%"}} content=" Bill Date" />
              <Text style={{ ...styles.columnHeader, width: '20%' }} content="Patient Name" />
              <Text style={{...styles.columnHeader,width:"10%"}} content="Uhid No." />
              <Text style={{...styles.columnHeader,width:"10%"}} content="Paymode" />
              <Text style={{ ...styles.columnHeader, width: '20%' }} content="Consultant" />
              <Text style={{ ...styles.columnHeader, width: '20%' }} content="Services" />
              <Text style={{ ...styles.columnHeader, width: '10%' }} content="Panel" />
              <Text style={{...styles.columnHeader,width:"10%"}} content="Recd Amt." />
              <Text style={{...styles.columnHeader,width:"20%"}} content="Ref by" />
            </View>
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="OPD Registration " />
            </View>
            {data &&
              data?.opdData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width: '10%'}} content={index + 1} />
                  <Text style={{...styles.columnContent,width:"10%"}} content={formatDate(data?.date)} />
                  <Text style={{ ...styles.columnContent, width: '20%', textAlign:'left' }}
                    content={`${data.name_suffix} ${data.first_name} ${data.last_name}`} />
                  <Text style={{...styles.columnContent,width:"10%"}} content={data.uhid} />
                  <Text style={{...styles.columnContent,width:'10%'}} content={data.payment_mode} />
                  <Text style={{ ...styles.columnContent, width: '20%' }} content={data.consultant.name} />
                  <Text style={{...styles.columnContent, width:'20%'}} content="Consulatancy" />
                  <Text style={{...styles.columnContent,width:"10%"}} content={data.sponsor.name} />
                  <Text style={{...styles.columnContent, textAlign:'right',width:"10%"}} content={data.recd} />
                  <Text style={{...styles.columnContent,width:"20%"}} content={data.refby?.referral_name} />
                </View>
              ))}
            <View style={{ ...styles.row, marginLeft: '75%', width: '100%' }}>
              <Text style={{...styles.columnContent1, fontSize:'10px', color:'red', marginRight:'9px' }} content="TOTAL :" />
              <Text style={{...styles.columnContent1, width:'44px',fontSize:'10px'  }} content={Math.round(data.opdData.stats.recd_amt)} />
            </View>
            {/* OPD Billing Data Section */}
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="OPD Billing" />
            </View>
            {data &&
              data?.opdBillingData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width: '10%'}} content={index + 1} />
                  <Text style={{...styles.columnContent,width:"10%"}} content={formatDate(data?.date)} />
                  <Text style={{ ...styles.columnContent, width: '20%', textAlign:'left' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`} />
                  <Text style={{...styles.columnContent,width:"10%"}} content={data.uhid} />
                  <Text style={{...styles.columnContent,width:"10%"}} content={data.pay_mode} />
                  <Text style={{ ...styles.columnContent, width: '20%' }} content={data.patient.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '20%' }} content={data.combinedServiceDetails
                      .map(({ service_name, test_name }) => service_name || test_name)
                      .join(', ')} />
                  <Text style={styles.columnContent} content={data.patient.sponsor.name} />
                  <Text style={{...styles.columnContent, textAlign:'right',width:"10%"}} content={data.total_recd} />
                  <Text style={{...styles.columnContent,width:"20%"}} content={data?.patient?.refby?.referral_name} />
                </View>
              ))}
            {/* Add the billing stats for OPD data */}
            <View style={{ ...styles.row, marginLeft: '75%', width: '100%' }}>
              <Text style={{...styles.columnContent1, fontSize:'10px', color:'red', marginRight:'8px' }} content="TOTAL :" />
              <Text style={{...styles.columnContent1, width:'44px',fontSize:'10px'  }} content={Math.round(data.opdBillingData.stats.recd_amt)} />
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default DoctorWiseOpdProceduresReportPdf;
